import {REWARD_SVG, REWARD_CLOSE_SVG} from './staticTypes'
const Launcher = (props) => {
	
	const { launcherFlag, onClick } = props;
	return (
		<div>
			<div className="rewards-button">
				<button className="launcher-button" onClick = { () => onClick(!launcherFlag) }  aria-label="Open wantdo.io Rewards Program">
					<div className={
						`launcher-container background-primary wantdo-launcher-border-radius-circular wantdo-launcher-image-only
							${launcherFlag === false ? 'launcher-closed':'launcher-open'}
						`
						}
						tabIndex="-1">

						<div className="launcher-content-container">
							{REWARD_SVG}
						</div>


						<div className="launcher-close-icon close-btn">
							{REWARD_CLOSE_SVG}
						</div>
					</div>
				</button>
			</div>
		</div>
	)
}

export default Launcher;

